<template>
  <div class="monitor_wrapper">
    <page>
      <!-- <nav-title>
          <div slot="title">测风监控</div>
        </nav-title> -->
      <div class="monitor_table_wrapper">
        <pagination-table
          :data="data"
          :columns="columns"
          :actions="actions"
          :loader="getMailTowerList"
          :async="true"
          :pageSizes="10"
          :border="true"
          class="solid-table"
        ></pagination-table>
        <upload-dialog
          :visible="showUpload"
          @close="closeUploadDialog"
        ></upload-dialog>
      </div>
    </page>
  </div>
</template>
<script>
import { getToken } from '@/utils';
export default {
  data() {
    return {
      columns: [
        {
          prop: 'owner',
          label: '测风塔编号',
          width: '150px'
        },
        {
          prop: 'count',
          label: '文件数',
          width: '150px'
        },
        {
          prop: 'lastTime',
          label: '最新邮件时间'
        }
      ],
      actions: [
        {
          label: '下载',
          type: 'default',
          style: 'link',
          href: (index, row) => {
            return `${
              process.env.VUE_APP_API_HOST_WINDDATA
            }/winddata/towerWarning/downloadMailTower?apiKey=${getToken()}&owner=${
              row.owner
            }`;
          }
        }
      ],
      data: []
    };
  },
  methods: {
    async getMailTowerList(options) {
      //console.log(options, 'options..');

      const { data } = await this.$fetch.get(
        '/winddata/towerWarning/getMailTowerList',
        {
          module: 'windData',
          params: { pageNo: options.page },
          showLoading: true
        }
      );
      const { data: resData } = data;
      this.data = resData.rows.map(item => {
        item.path = true;
        return item;
      });
      return { data: this.data, total: resData.total };
    }
  },
  mounted() {}
};
</script>
<style lang="less">
.monitor_wrapper {
  padding: 15px 26px;
}
.monitor_table_wrapper {
  margin-top: 15px;
}
</style>
